module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch02"
    }
  }, [_c('b', [_vm._v("One & Only")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Colorado is the only state to have turned down the opportunity to host the Olympics, in 1976.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The only player in the Los Angeles Dodgers’ starting lineup with a batting average of .300 or better going into the 1965 World Series was pitcher Don Drysdale.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only cats born with no tail: the Manx. The breed carries a genetic mutation that causes the abnormality.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only all-female African American military unit to deploy to Europe during World War II: the 888th Central Postal Directory Battalion, out of Georgia. They sorted and delivered mail to soldiers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Frank Zappa’s only Top-40 song: “Valley Girl,” in 1982 (it reached #32).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only player to get caught stealing to end the World Series: Babe Ruth, in 1926.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("According to "), _c('i', [_vm._v("Billboard")]), _vm._v(", only two songs with the word “summer” in the title have reached number one: “Summer in the City” and “Theme from a Summer Place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only Norwegian band with international success: a-ha. Biggest hit: “Take on Me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Michelangelo signed only one of his sculptures—the "), _c('i', [_vm._v("Pietà")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only golfer to spend 30 minutes on a single hole in the U.S. Open: Ray Ainsley (1938).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The only member of Pink Floyd to play on every one of the band’s albums: drummer Nick Mason.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Shirley Bassey is the only artist to have recorded songs for more than one James Bond movie ("), _c('i', [_vm._v("Goldfinger")]), _vm._v(", "), _c('i', [_vm._v("Diamonds Are Forever")]), _vm._v(", and "), _c('i', [_vm._v("Moonraker")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The only horse to defeat Man o’ War was named Upset.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bab2f1ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 78
// module chunks = 0